import { Component, OnDestroy, OnInit } from "@angular/core";
import { ToastController } from "@ionic/angular";
import { Subscription } from "rxjs";
import { CadastroPerguntasService } from "src/app/core/services/behavior/cadastro-perguntas.service";
import { AuthenticationService } from "src/app/core/services/http/authentication.service";
import { ProdutoService } from "src/app/core/services/http/produto.service";
import { PerguntaFamiliaRequest, PerguntaProdutoRequest, PerguntaViewModel, RespostaFamiliaRequest, RespostaProdutoRequest, RespostaViewModel } from "src/app/shared/models/pergunta.model";
import { CastModelUtils } from "src/app/shared/utils/CastModelUtils";

@Component({
    selector: 'app-cadastro-perguntas',
    templateUrl: './cadastro-perguntas.page.html',
    styleUrls: ['./cadastro-perguntas.page.scss'],
})
export class CadastroPerguntasPage implements OnInit, OnDestroy {
    private codigoProduto: number = 0;
    private codigoFamilia: number = 0;
    public displayedColumnsPerguntas: string[] = ['pergunta', 'editar', 'deletar', 'respostas'];
    public displayedColumnsRespostas: string[] = ['resposta', 'editar', 'deletar'];
    public perguntaSel: PerguntaViewModel = new PerguntaViewModel();
    public respostaSel: RespostaViewModel = new RespostaViewModel();
    public termoBusca: string = '';
    public perguntas: PerguntaViewModel[] = [];
    public respostas: RespostaViewModel[] = [];
    public dataSourcePergutas = this.perguntas;
    public dataSourceRespostas = this.respostas;
    public cadastroRespostas: boolean = false;
    public tituloPadrao: string = "Cadastro de pergunta e resposta";
    public titulo = this.tituloPadrao;
    public desativarBtnGravar: boolean = false;
    public ehFamilia: boolean = false;
    public ehProduto: boolean = false;

    private subscriptions: Subscription[] = [];

    constructor(
        private produtoService: ProdutoService,
        private authService: AuthenticationService,
        private cadastroPerguntaService: CadastroPerguntasService,
        private toastController: ToastController
    ) {
        const codigoProdutoSub = this.cadastroPerguntaService.codigoProduto.subscribe((res) => {
            this.codigoProduto = res;
            this.ehProduto = res > 0;
        });

        const codigoFamiliaSub = this.cadastroPerguntaService.codigoFamilia.subscribe((res) => {
            this.codigoFamilia = res;
            this.ehFamilia = res > 0;
        });

        this.subscriptions.push(codigoProdutoSub, codigoFamiliaSub);
    }

    ngOnInit(): void {
        this.carregarPerguntas();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }

    private carregarPerguntas() {
        this.authService.isAuthenticated.subscribe((autenticado) => {
            if (!autenticado) {
                return;
            }

            if (!this.validarCodigos()) {
                return;
            }

            const getPerguntas = this.ehProduto ? this.produtoService.getPerguntasPorCodigoProduto(this.codigoProduto) : this.produtoService.getPerguntasPorCodigoFamilia(this.codigoFamilia);

            getPerguntas.subscribe((res) => {
                if (!res.success) {
                    return;
                }

                const perguntasViewModel: PerguntaViewModel[] = [];

                for (const pergunta of res.data) {
                    const respostas = pergunta.respostas.map((resposta) => CastModelUtils.ClonarObjetoComPropriedadesIguais(resposta, new RespostaViewModel()));
                    const perguntaViewModel = CastModelUtils.ClonarObjetoComPropriedadesIguais(pergunta, new PerguntaViewModel());

                    perguntaViewModel.respostas = respostas;

                    perguntasViewModel.push(perguntaViewModel);
                }

                this.perguntas = perguntasViewModel;
                this.buscar();
            });
        });
    }

    public buscar() {
        const termo = this.termoBusca.toLowerCase();
        this.dataSourcePergutas = structuredClone(this.perguntas.filter((pergunta) => pergunta.pergunta.toLowerCase().includes(termo)));
    }

    public exibirRespostas(pergunta: PerguntaViewModel) {
        this.respostas = pergunta.respostas;
        this.respostaSel.codigoPergunta = pergunta.codigo;

        this.titulo = pergunta.pergunta;

        this.cadastroPerguntaService.nomePergunta.next(pergunta.pergunta);

        this.dataSourceRespostas = structuredClone(this.respostas);
        this.cadastroRespostas = true;
    }

    public cadastrarPergunta() {
        if (!this.perguntaSel.validar() || !this.validarCodigos()) {
            this.mostrarToast('Campos inválidos');
            return;
        }

        const perguntaSelCache = CastModelUtils.ClonarObjetoComPropriedadesIguais(this.perguntaSel, new PerguntaViewModel());
        this.desativarBtnGravar = true

        const perguntaRequest = this.convertPerguntaToRequest(this.perguntaSel);

        const perguntaRequestProduto: PerguntaProdutoRequest = CastModelUtils.ClonarObjetoComPropriedadesIguais(perguntaRequest, new PerguntaProdutoRequest());
        const perguntaRequestFamilia: PerguntaFamiliaRequest = CastModelUtils.ClonarObjetoComPropriedadesIguais(perguntaRequest, new PerguntaFamiliaRequest());

        const createPergunta = this.ehProduto ? this.produtoService.createPergunta(perguntaRequestProduto) : this.produtoService.createPerguntaFamilia(perguntaRequestFamilia);

        createPergunta.subscribe({
            next: (res) => {
                this.desativarBtnGravar = false;
                if (!res.success) return;

                perguntaSelCache.codigo = res.data.codigo;
                this.perguntas = [...this.perguntas, perguntaSelCache];

                this.buscar();
                this.limparForm();
            },
            error: () => {
                this.desativarBtnGravar = false;
                this.mostrarToast('Erro ao gravar nova pergunta');
            }
        });
    }

    private convertPerguntaToRequest(pergunta: PerguntaViewModel): PerguntaProdutoRequest | PerguntaFamiliaRequest {
        let perguntaRequest = null;

        if (this.ehProduto) {
            const perguntaRequestProduto = new PerguntaProdutoRequest();

            perguntaRequestProduto.codigo = pergunta.codigo;
            perguntaRequestProduto.pergunta = pergunta.pergunta;
            perguntaRequestProduto.qtdMinEscolhas = pergunta.qtdMinEscolhas;
            perguntaRequestProduto.qtdMaxEscolhas = pergunta.qtdMaxEscolhas;
            perguntaRequestProduto.codigoProduto = this.codigoProduto;

            perguntaRequest = perguntaRequestProduto;
        }

        if (this.ehFamilia) {
            const perguntaRequestFamilia = new PerguntaFamiliaRequest();

            perguntaRequestFamilia.codigo = pergunta.codigo;
            perguntaRequestFamilia.pergunta = pergunta.pergunta;
            perguntaRequestFamilia.qtdMinEscolhas = pergunta.qtdMinEscolhas;
            perguntaRequestFamilia.qtdMaxEscolhas = pergunta.qtdMaxEscolhas;
            perguntaRequestFamilia.codigoFamilia = this.codigoFamilia;

            perguntaRequest = perguntaRequestFamilia;
        }

        return perguntaRequest
    }

    public cadastrarResposta() {
        if (!this.respostaSel.validar() || !this.validarCodigos()) {
            this.mostrarToast('Erro ao validar campos de respostas');
            return;
        };

        let respostaSelCache = CastModelUtils.ClonarObjetoComPropriedadesIguais(this.respostaSel, new RespostaViewModel());
        this.desativarBtnGravar = true;

        const respostaRequest = this.convertRespostaToRequest(this.respostaSel);

        const respostaRequestProduto: RespostaProdutoRequest = CastModelUtils.ClonarObjetoComPropriedadesIguais(respostaRequest, new RespostaProdutoRequest());
        const respostaRequestFamilia: RespostaFamiliaRequest = CastModelUtils.ClonarObjetoComPropriedadesIguais(respostaRequest, new RespostaFamiliaRequest());

        const createResposta = this.ehProduto ? this.produtoService.createProdutoResposta(respostaRequestProduto) : this.produtoService.createFamiliaResposta(respostaRequestFamilia);

        createResposta.subscribe((res) => {
            this.desativarBtnGravar = false;
            if (!res.success) return;

            respostaSelCache = res.data as any;

            const perguntaEncontrada = this.perguntas.find((p) => p.codigo === respostaRequest.codigoPergunta);
            perguntaEncontrada.respostas = [...perguntaEncontrada.respostas, respostaSelCache];

            this.respostas = [...this.respostas, respostaSelCache];

            this.dataSourceRespostas = this.respostas;

            this.buscar();
            this.limparFormResposta();
        });
    }

    private convertRespostaToRequest(resposta: RespostaViewModel): RespostaProdutoRequest | RespostaFamiliaRequest {
        let respostaRequest = null;

        if (this.ehProduto) {
            const respostaRequestProduto = new RespostaProdutoRequest();

            respostaRequestProduto.codigoPergunta = resposta.codigoPergunta;
            respostaRequestProduto.codigoProduto = this.codigoProduto;
            respostaRequestProduto.resposta = resposta.resposta;
            respostaRequestProduto.codigo = resposta.codigo;

            respostaRequest = respostaRequestProduto;
        }

        if (this.ehFamilia) {
            const respostaRequestFamilia = new RespostaFamiliaRequest();

            respostaRequestFamilia.codigoPergunta = resposta.codigoPergunta;
            respostaRequestFamilia.codigoFamilia = this.codigoFamilia;
            respostaRequestFamilia.resposta = resposta.resposta;
            respostaRequestFamilia.codigo = resposta.codigo;

            respostaRequest = respostaRequestFamilia;
        }

        return respostaRequest
    }

    private validarCodigos(): boolean {
        if (!this.ehFamilia && !this.ehProduto) {
            throw new Error('Código família ou código produto não pode ser 0!');
        }

        if (this.ehProduto === this.ehFamilia) {
            throw new Error('Não pode existir código família e código produto dentro do cadastro de perguntas ao mesmo tempo');
        }

        return true;
    }

    public editarPergunta(pergunta: PerguntaViewModel) {
        this.limparForm();

        this.perguntaSel = CastModelUtils.ClonarObjetoComPropriedadesIguais(pergunta, new PerguntaViewModel());
        this.perguntaSel.emEdicao = true;
    }

    public editarResposta(resposta: RespostaViewModel) {
        this.respostaSel = structuredClone(resposta);
        this.respostaSel.emEdicao = true;
    }

    public confirmarAlteracaoPergunta() {
        let indexPergunta = this.perguntas.findIndex((p) => p.codigo === this.perguntaSel.codigo);

        if (!this.perguntaSel.validar() || !this.validarCodigos()) {
            this.mostrarToast('Erro ao validar campos para alteração da pergunta');
            return;
        };

        const respostasRequest: (RespostaProdutoRequest | RespostaFamiliaRequest)[] = this.perguntaSel.respostas.map((res) => {
            return this.convertRespostaToRequest(res);
        });

        // const respostasRequest: RespostaProdutoRequest[] = this.perguntaSel.respostas.map((resposta) => {
        //     const respostaRequest: RespostaProdutoRequest = new RespostaProdutoRequest();

        //     respostaRequest.codigoPergunta = resposta.codigoPergunta;
        //     respostaRequest.codigoProduto = this.codigoProduto;
        //     respostaRequest.resposta = resposta.resposta;

        //     return respostaRequest;
        // });

        const perguntaSelCache = CastModelUtils.ClonarObjetoComPropriedadesIguais(this.perguntaSel, new PerguntaViewModel());
        this.desativarBtnGravar = true;

        const perguntaRequest = this.convertPerguntaToRequest(this.perguntaSel);
        perguntaRequest.respostas = this.ehProduto ? respostasRequest as RespostaProdutoRequest[] : respostasRequest as RespostaFamiliaRequest[];

        const perguntaProdutoRequest: PerguntaProdutoRequest = CastModelUtils.ClonarObjetoComPropriedadesIguais(perguntaRequest, new PerguntaProdutoRequest());
        const perguntaFamiliaRequest: PerguntaFamiliaRequest = CastModelUtils.ClonarObjetoComPropriedadesIguais(perguntaRequest, new PerguntaFamiliaRequest());

        // const alterarPergunta = this.ehProduto ? this.produtoService.alterarProdutoPergunta(perguntaProdutoRequest) : this.produtoService.alterarFamiliaPergunta(perguntaFamiliaRequest);
        const alterarPergunta = this.ehProduto ? this.produtoService.alterarProdutoPergunta(perguntaProdutoRequest) : this.produtoService.alterarFamiliaPergunta(perguntaFamiliaRequest);

        // const perguntaRequest: PerguntaProdutoRequest = new PerguntaProdutoRequest();

        // perguntaRequest.codigo = this.perguntaSel.codigo;
        // perguntaRequest.codigoProduto = this.codigoProduto;
        // perguntaRequest.pergunta = this.perguntaSel.pergunta;
        // perguntaRequest.qtdMinEscolhas = this.perguntaSel.qtdMinEscolhas;
        // perguntaRequest.qtdMaxEscolhas = this.perguntaSel.qtdMaxEscolhas;
        // perguntaRequest.respostas = respostasRequest;

        alterarPergunta.subscribe((res) => {
            this.desativarBtnGravar = false;
            if (!res.success) return;

            if (indexPergunta !== null) this.perguntas[indexPergunta] = perguntaSelCache;
            this.dataSourcePergutas = this.perguntas;
            this.limparForm();
        });
    }

    public confirmarAlteracaoResposta() {
        this.desativarBtnGravar = true;

        const respostaRequest = this.convertRespostaToRequest(this.respostaSel);

        const alterarResposta = this.ehProduto ? this.produtoService.alterarProdutoResposta(respostaRequest as RespostaProdutoRequest) : this.produtoService.alterarFamiliaResposta(respostaRequest as RespostaFamiliaRequest);

        const respostaSelCache = CastModelUtils.ClonarObjetoComPropriedadesIguais(this.respostaSel, new RespostaViewModel())

        alterarResposta.subscribe((res) => {
            this.desativarBtnGravar = false;
            
            if (!res.success) return;
            
            let indexResposta = this.respostas.findIndex((r) => r.codigo === this.respostaSel.codigo);
            
            if (indexResposta !== null) this.respostas[indexResposta] = respostaSelCache;
            this.dataSourceRespostas = this.respostas.map((resposta) => CastModelUtils.ClonarObjetoComPropriedadesIguais(resposta, new RespostaViewModel()));

            this.buscar();
            this.limparFormResposta();
        });
    }

    public duplaConfirmacaoDeletarPergunta(pergunta: PerguntaViewModel) {
        if (pergunta.emDeletacao) {
            this.deletarPergunta(pergunta);
            return;
        }

        pergunta.emDeletacao = true;
        setTimeout(() => pergunta.emDeletacao = false, 2000);
    }

    public duplaConfirmacaoDeletarResposta(resposta: RespostaViewModel) {
        if (resposta.emDeletacao) {
            this.deletarResposta(resposta);
            return;
        }

        resposta.emDeletacao = true;
        setTimeout(() => resposta.emDeletacao = false, 2000);
    }

    private deletarPergunta(pergunta: PerguntaViewModel) {
        const removerResposta = this.ehProduto ? this.produtoService.removerProdutoPergunta(pergunta.codigo) : this.produtoService.removerFamiliaPergunta(pergunta.codigo);

        removerResposta.subscribe((res) => {
            if (!res.success) return;

            this.perguntas = this.perguntas.filter((p) => p.codigo !== pergunta.codigo);
            this.buscar();
        });
    }

    private deletarResposta(resposta: RespostaViewModel) {
        const removerResposta = this.ehProduto ? this.produtoService.removerProdutoResposta(resposta.codigo) : this.produtoService.removerFamiliaResposta(resposta.codigo);

        removerResposta.subscribe((res) => {
            if (!res.success) return;

            this.respostas = this.respostas.filter((r) => r.codigo !== resposta.codigo);
            this.dataSourceRespostas = this.respostas;
            this.deletarRespostaNaPergunta(resposta);
        });
    }

    private deletarRespostaNaPergunta(resposta: RespostaViewModel) {
        const pergunta = this.perguntas.find((pergunta) => pergunta.codigo === resposta.codigoPergunta);

        if (pergunta === null) return;

        pergunta.respostas = pergunta.respostas.filter((r) => r.codigo !== resposta.codigo);
        this.buscar();
    }

    public limparForm() {
        this.perguntaSel.emEdicao = false;
        this.perguntaSel = new PerguntaViewModel();

        this.cadastroPerguntaService.nomePergunta.next(null);

        this.cadastroRespostas = false;
        this.titulo = this.tituloPadrao;
        this.respostas = [];
    }

    private limparFormResposta() {
        const codigoPergunta = this.respostaSel.codigoPergunta;

        this.respostaSel = new RespostaViewModel();
        this.respostaSel.codigoPergunta = codigoPergunta;
    }

    public cancelarEdicaoResposta() {
        this.respostaSel = new RespostaViewModel();
    }

    public selecionarTudo(event: FocusEvent) {
        const input = event.target as HTMLInputElement;
        input.select();
    }

    private async mostrarToast(message: string) {
        const toast = await this.toastController.create({
            message: message,
            duration: 2000,
            position: 'bottom',
            color: 'danger',
        });

        await toast.present();
    }
}